import { postToApiPath } from '../shared/utilities/apiClient';
import { BulkFormActionResult } from '../types/bulkFormActionResult';

export const bulkSaveFormStatus = (
    formIds: string[],
    formStatus: number,
    toastText?: {
        onPendingText?: string;
    }
) =>
    postToApiPath<BulkFormActionResult>(
        'testapp/forms/bulk/status',
        { formIds, formStatus },
        {
            headers: {
                'Toast-Pending-Text': toastText?.onPendingText,
                SkipSuccessToast: true,
            },
        }
    )
        .then((res) => res.data)
        .catch((error) => {
            throw error;
        });
